<template>
  <LayoutUser>
    <Loading
      v-if="showLoading"
      :isLoading="isLoading"
      @reload="getDataLoading"
    />
    <ul class="list">
      <li
        class="list-item"
        v-for="item in list"
        :key="item.id"
        @click="$router.push(`/inspectionResults/${item.crId}`)"
      >
        <p>{{ item.ctitle }}</p>
        <div class="desc">
          <span>检查时间：{{ item.crChecktime }}</span>
          <span>检查类型：{{ item.ctypeName }}</span>
        </div>
      </li>
    </ul>
    <Empty v-if="!list.length" />
  </LayoutUser>
</template>

<script>
import { computed, ref } from 'vue'
import { useGetDataLoading } from '@/hooks/useGetDataLoading'
import { useStore } from 'vuex'
import { getDetailListByComId } from '@/api/salehome'
import Empty from '../../components/Empty.vue'

export default {
  components: { Empty },
  name: 'InspectionResultsList',
  setup () {
    const store = useStore()
    const companyId = computed(() => store.state.roleInfo.companyId)
    const list = ref('')
    const { getDataLoading, showLoading, isLoading } = useGetDataLoading(
      getDetailListByComId,
      data => {
        list.value = data
      },
      companyId.value
    )
    getDataLoading()
    return { getDataLoading, showLoading, isLoading, list }
  }
}
</script>

<style lang="scss" scoped>
.list {
  padding: 0 16px;
  font-size: 14px;
  .list-item {
    background-color: #fff;
    padding: 10px 16px;
    margin-top: 16px;
    border-radius: 5px;
    p {
      margin: 0;
      line-height: 28px;
      font-weight: 600;
    }
    .desc {
      color: #666;
      font-size: 12px;
      span {
        margin-right: 10px;
      }
    }
  }
}
</style>
